export const PAYOUT_STATUS = {
  AWAITING_CONFIRMATION: "Awaiting confirmation in CryptemberBot", REQUESTED: "Requested — commission reserved",
  PROCESSING: "Processing", PAID: "Paid", CANCELLED: "Cancelled", REJECTED: "Rejected", EXPIRED: "Expired",
};
export const money = (value) => `${Number(value || 0).toFixed(2)} USDT`;
export const safeDate = (value) => value ? new Date(value).toLocaleString() : "—";
